import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/auth.guard';
import { ServiceProvidersDetails2Component } from './module/service-provider/service-providers-details-2/service-providers-details-2.component';
import { UserDetailsComponent } from './module/users/user-details/user-details.component';
import { ServiceAdvisorDetailsComponent } from './module/service-advisors/service-advisor-details/service-advisor-details.component';
import { ProfileComponent } from './module/profile/profile.component';
import { UnderConstructionComponent } from './page404/under-construction/under-construction.component';
import { RoleGuard } from './AuthGuard/Role/role.guard';
import { ServiceDistributorDetailsComponent } from './service-distributor/service-distributor-details/service-distributor-details.component';
import { AddSpComponent } from './module/service-provider/add-sp-new-component/add-sp/add-sp.component';
import { MakePaymentComponent } from './component/make-payment/make-payment.component';
import { AddBalanceComponent } from './module/Dashboard/dashboard/add-balance/add-balance.component';
import { AddBalanceWalletComponent } from './component/add-balace-wallet/add-balace-wallet.component';
import { AddServiceAdvisorComponent } from './module/service-advisors/add-service-advisor/add-service-advisor.component';
import { AddUserComponent } from './module/users/add-user/add-user.component';
import { AddDistributorComponent } from './service-distributor/add-distributor/add-distributor.component';
import { WalletComponent } from './module/Dashboard/dashboard/wallet/wallet.component';
import { DistributorWalletComponent } from './component/distributor-wallet/distributor-wallet.component';
import { ELockerComponent } from './module/Locker/e-locker/e-locker.component';
import { PromotionsComponent } from './module/Dashboard/dashboard/promotions/promotions.component';
import { PromotionDashboardComponent } from './component/promotion-dashboard/promotion-dashboard.component';
import { PromotionAnalyticsComponent } from './component/promotion-analytics/promotion-analytics.component';
import { OtpPageComponent } from './otp-page/otp-page.component';
import { TicketsDetailsComponent } from './module/support/tickets-details/tickets-details.component';
import { RaiseTicketComponent } from './module/support/raise-ticket/raise-ticket.component';

const routes: Routes = [
  { path: '', redirectTo: getDashboardPath(), pathMatch: 'full' },

  {
    path: 'login',
    loadChildren: () =>
      import('./module/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'payment',
    component: MakePaymentComponent,
    canActivate: [AuthGuard],
    // data: { allowedRoles: [4] }
  },
  { path: 'otp', component: OtpPageComponent},
  {
    path: 'add-balance-wallet',
    component: AddBalanceWalletComponent,
    canActivate: [AuthGuard],
    // data: { allowedRoles: [4] }
  },
  // Admin-specific routing (accessType = 0)
  {
    path: 'admin',
    canActivate: [AuthGuard, RoleGuard],
    data: { allowedRoles: [0] },
    children: [
      { path: 'role-permission', loadChildren: () => import('./module/role-permission/role-permission.module').then(m => m.RolePermissionModule) },
      {
        path: 'wallet',
        component: DistributorWalletComponent,
        data: { allowedRoles: [0] },
      },
      {
        path: 'vehicle-service-provider',
        loadChildren: () =>
          import('./module/service-provider/service-provider.module').then(
            (m) => m.ServiceProviderModule
          ),
        data: { allowedRoles: [0] },

      },
      {
        path: 'vehicle-service-provider/:serviceProviderId',
        component: ServiceProvidersDetails2Component,
        data: { allowedRoles: [0] },
      },
      {
        path: 'vehicle-service-provider/:serviceProviderId/edit-vehicle-service-provider',
        component: AddSpComponent,
        data: { allowedRoles: [0] },
      },
      {
        path: 'vehicle-owners',
        loadChildren: () =>
          import('./module/users/users.module').then((m) => m.UsersModule),
        data: { allowedRoles: [0] },
      },
      {
        path: 'vehicle-owners/:customerId',
        component: UserDetailsComponent,
        data: { allowedRoles: [0] },
      },
      {
        path: 'vehicle-owners/:customerId/edit-vehicle-owner',
        component: AddUserComponent,
        data: { allowedRoles: [0] },
      },
      {
        path: 'technical-advisors',
        loadChildren: () =>
          import('./module/service-advisors/service-advisors.module').then(
            (m) => m.ServiceAdvisorsModule
          ),
        data: { allowedRoles: [0] },
      },
      {
        path: 'technical-advisors/:serviceAdvisorId',
        component: ServiceAdvisorDetailsComponent,
        data: { allowedRoles: [0] },
      },
      {
        path: 'technical-advisors/:serviceAdvisorId/edit-technical-advisor',
        component: AddServiceAdvisorComponent,
        data: { allowedRoles: [0] },
      },
      {
        path: 'distributor-partners',
        loadChildren: () =>
          import('./service-distributor/service-distributor.module').then(
            (m) => m.ServiceDistributorModule
          ),
        data: { allowedRoles: [0] },
      },
      {
        path: 'distributor-partners/:distributorId',
        component: ServiceDistributorDetailsComponent,
        data: { allowedRoles: [0] },
      },
      {
        path: 'distributor-partners/:distributorId/edit-distributor-partner',
        component: AddDistributorComponent,
        data: { allowedRoles: [0] },
      },
      {
        path: 'invoicing',
        loadChildren: () => import('./invoicing/invoicing.module').then(m => m.InvoicingModule)
      },
      // {
      //   path: 'locker',
      //   component: ELockerComponent,
      //   data: { allowedRoles: [0] },
      // }
      {
        path: 'locker',
        loadChildren: () => import('./module/Locker/e-locker/e-locker.module').then(m => m.ELockerModule),
        data: { allowedRoles: [0] },
      },
      {
        path: 'user-dashboard',
        loadChildren: () =>
          import('./module/user-dashboard/user-dashboard.module').then(
            (m) => m.UserDashboardModule
          ),

      },

      {
        path: 'support',
        loadChildren: () =>
          import('./module/support/support.module').then((m) => m.SupportModule), data: { allowedRoles: [0] },
      },
      {
        path: 'support/tickets/:ticketId',
        component: TicketsDetailsComponent,
        data: { allowedRoles: [0] },
      },
    ],
  },

  // Distributor-specific routing (accessType = 4)
  {
    path: 'distributor-partners',
    canActivate: [AuthGuard, RoleGuard],
    data: { allowedRoles: [4] },
    children: [
      // {
      //   path: 'promotions', component: PromotionsComponent
      // },
      {
        path: 'wallet',
        component: DistributorWalletComponent,
        data: { allowedRoles: [4] },
      },
      {
        path: 'vehicle-service-provider',
        loadChildren: () =>
          import('./module/service-provider/service-provider.module').then(
            (m) => m.ServiceProviderModule
          ),
        data: { allowedRoles: [4] },
      },
      {
        path: 'vehicle-service-provider/:serviceProviderId',
        component: ServiceProvidersDetails2Component,
        data: { allowedRoles: [4] },
      },
      {
        path: 'vehicle-service-provider/:serviceProviderId/edit-vehicle-service-provider',
        component: AddSpComponent,
        data: { allowedRoles: [4] },
      },
      {
        path: 'vehicle-owners',
        loadChildren: () =>
          import('./module/users/users.module').then((m) => m.UsersModule),
        data: { allowedRoles: [4] },
      },
      {
        path: 'vehicle-owners/:customerId',
        component: UserDetailsComponent,
        data: { allowedRoles: [4] },
      },
      {
        path: 'vehicle-owners/:customerId/edit-vehicle-owner',
        component: UserDetailsComponent,
        data: { allowedRoles: [4] },
      },
      {
        path: 'technical-advisors',
        loadChildren: () =>
          import('./module/service-advisors/service-advisors.module').then(
            (m) => m.ServiceAdvisorsModule
          ),
        data: { allowedRoles: [4] },
      },
      {
        path: 'technical-advisors/:serviceAdvisorId',
        component: ServiceAdvisorDetailsComponent,
        data: { allowedRoles: [4] },
      },
      {
        path: 'technical-advisors/:serviceAdvisorId/edit-technical-advisor',
        component: AddServiceAdvisorComponent,
        data: { allowedRoles: [4] },
      },
      {
        path: 'distributor-partners',
        loadChildren: () =>
          import('./service-distributor/service-distributor.module').then(
            (m) => m.ServiceDistributorModule
          ),
        canActivate: [AuthGuard, RoleGuard],
        data: { allowedRoles: [0] },
      },
      {
        path: 'distributor-partners/:distributorId',
        component: ServiceDistributorDetailsComponent,
        data: { allowedRoles: [4] },
      },
      {
        path: 'distributor-partners/:distributorId/edit-distributor-partner',
        component: AddDistributorComponent,
        data: { allowedRoles: [4] },
      },
      {
        path: 'support',
        loadChildren: () =>
          import('./module/support/support.module').then((m) => m.SupportModule), data: { allowedRoles: [4] },
      },
      {
        path: 'support/tickets/:ticketId',
        component: TicketsDetailsComponent,
        data: { allowedRoles: [4] },
      },
      {
        path: 'invoicing',
        loadChildren: () => import('./invoicing/invoicing.module').then(m => m.InvoicingModule)
      },
      // {
      //   path: 'locker',
      //   component: ELockerComponent,
      //   data: { allowedRoles: [4] },
      // }
      {
        path: 'locker',
        loadChildren: () => import('./module/Locker/e-locker/e-locker.module').then(m => m.ELockerModule)
      },
      {
        path: 'user-dashboard',
        loadChildren: () =>
          import('./module/user-dashboard/user-dashboard.module').then(
            (m) => m.UserDashboardModule
          ),
      },
      {
        path: 'promotion', component: PromotionDashboardComponent
      },
      {
        path: 'promotion/:promotionId/analytics', component: PromotionAnalyticsComponent
      }
    ],
  },
  // under process
  {
    path: 'under-Construction',
    component: UnderConstructionComponent,
  },
  // Shared or general routes
  {
    path: 'c-sp',
    loadChildren: () =>
      import('./module/Dashboard/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: { allowedRoles: [1] },
  },



  // {
  //   path: 'sa',
  //   loadChildren: () =>
  //     import('./module/Dashboard/dashboard/dashboard.module').then(
  //       (m) => m.DashboardModule
  //     ),
  //   canActivate: [AuthGuard, RoleGuard],
  //   data: { allowedRoles: [3] },
  // },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'technical-advisors',
    canActivate: [AuthGuard, RoleGuard],
    data: { allowedRoles: [3] },
    children: [
      {
        path: 'wallet',
        component: DistributorWalletComponent,
        data: { allowedRoles: [3] },
      },
      {
        path: 'vehicle-service-provider',
        loadChildren: () =>
          import('./module/service-provider/service-provider.module').then(
            (m) => m.ServiceProviderModule
          ),
        data: { allowedRoles: [3] },
      },
      {
        path: 'vehicle-service-provider/:serviceProviderId',
        component: ServiceProvidersDetails2Component,
        data: { allowedRoles: [3] },
      },
      {
        path: 'vehicle-service-provider/:serviceProviderId/edit-vehicle-service-provider',
        component: AddSpComponent,
        data: { allowedRoles: [3] },
      },
      {
        path: 'vehicle-owners',
        loadChildren: () =>
          import('./module/users/users.module').then((m) => m.UsersModule),
        data: { allowedRoles: [3] },
      },
      {
        path: 'vehicle-owners/:customerId',
        component: UserDetailsComponent,
        data: { allowedRoles: [3] },
      },
      {
        path: 'vehicle-owners/:customerId/edit-vehicle-owner',
        component: AddUserComponent,
        data: { allowedRoles: [3] },
      },
      {
        path: 'technical-advisors',
        loadChildren: () =>
          import('./module/service-advisors/service-advisors.module').then(
            (m) => m.ServiceAdvisorsModule
          ),
        data: { allowedRoles: [3] },
      },
      {
        path: 'technical-advisors/:serviceAdvisorId',
        component: ServiceAdvisorDetailsComponent,
        data: { allowedRoles: [3] },
      },
      {
        path: 'technical-advisors/:serviceAdvisorId/edit-technical-advisor',
        component: AddServiceAdvisorComponent,
        data: { allowedRoles: [3] },
      },
      {
        path: 'distributor-partners',
        loadChildren: () =>
          import('./service-distributor/service-distributor.module').then(
            (m) => m.ServiceDistributorModule
          ),
        data: { allowedRoles: [3] },
      },
      {
        path: 'distributor-partners/:distributorId',
        component: ServiceDistributorDetailsComponent,
        data: { allowedRoles: [3] },
      },
      {
        path: 'distributor-partners/:distributorId/edit-distributor-partner',
        component: AddDistributorComponent,
        data: { allowedRoles: [3] },
      },
      {
        path: 'invoicing',
        loadChildren: () => import('./invoicing/invoicing.module').then(m => m.InvoicingModule)
      },
      // {
      //   path: 'locker',
      //   component: ELockerComponent,
      //   data: { allowedRoles: [0] },
      // }
      {
        path: 'locker',
        loadChildren: () => import('./module/Locker/e-locker/e-locker.module').then(m => m.ELockerModule),
        data: { allowedRoles: [0] },
      },
      {
        path: 'user-dashboard',
        loadChildren: () =>
          import('./module/user-dashboard/user-dashboard.module').then(
            (m) => m.UserDashboardModule
          ),
      },
      {
        path: 'support',
        loadChildren: () =>
          import('./module/support/support.module').then((m) => m.SupportModule), data: { allowedRoles: [3] },
      },
      {
        path: 'support/tickets/:ticketId',
        component: TicketsDetailsComponent,
        data: { allowedRoles: [3] },
      },
      
    ],
  },

];


//Function to determine the correct dashboard path
export function getDashboardPath(): string {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  console.log("User Data from LocalStorage:", user);
  console.log("Extracted accessType:", user.accessType);

  if (user.accessType === 1) {
    return 'sp';
  } else if (user.accessType === 3) {
    return 'sa';
  } else {
    return 'login'; // Fallback if accessType is missing
  }
}


@NgModule({
  imports: [
    RouterModule.forRoot(routes, { anchorScrolling: 'enabled', useHash: true }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
